import UsersTemplate from "../../../templates/admin/users";

const UsersScreen = () => {
  return <UsersTemplate />;
};

export default UsersScreen;
